// extracted by mini-css-extract-plugin
module.exports = {"base":"organism1-m__base__1nqCI","story-card":"organism1-m__story-card__1kflT"};